import { Modal, Button, Space, Col, Row, Form, Card, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { useState } from "react";
import FormAntd from "components/form/FormProvide/FormAntd";
import { FormInput } from "components/form/FormProvide";
import { ReactComponent as Visa } from "../../../assets/images/visa.svg";
import { ReactComponent as Mastercard } from "../../../assets/images/mastercard.svg";
import { ReactComponent as JCB } from "../../../assets/images/jcb.svg";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

function AdminCompanyModal({
  isModalOpen = false,
  onCancel = () => { },
  onSave = () => { },
}) {
  const { t } = useTranslation();
  const [isCreditModalOpen, setIsCreditModalOpen] = useState(false);
  const [isCreditInfoOpen, setIsCreditInfoOpen] = useState(false);
  const [form] = Form.useForm();

  const handCreditSave = () => {
    form.validateFields().then((values) => {
      onSave(values);
      setIsCreditModalOpen(false);
      setIsCreditInfoOpen(true)
      form.resetFields();
    });
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={() => {
        onCancel();
        setIsCreditModalOpen(false);
        setIsCreditInfoOpen(false);
      }}
      footer={null}
      centered
      maskClosable={false}
      // closable={false}
      width={"45vw"}
    >

      {!isCreditModalOpen && !isCreditInfoOpen && (
        <>
          <span style={{ fontSize: "18px", fontWeight: "bold" }}>
            {t("response_company.label.credit_card_detail")}
          </span>
          <p style={{ fontSize: "13px", color: "#667085" }}>
            {t("credit_information.credit_card_company_togetter")}
          </p>

          <Space
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 20,
              gap: 10,
            }}
          >
            <Button
              type="primary"
              icon={<CreateIcon />}
              style={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "var(--button-color)",
                fontSize: 16,
              }}
              size="large"
              onClick={() => setIsCreditModalOpen(true)}
            >
              {t("credit_information.add_credit_card")}
            </Button>

            <Button
              type="default"
              size="large"
              onClick={() => setIsCreditInfoOpen(true)}
            >
              {t("test")}
            </Button>
          </Space>
        </>
      )}

      {isCreditModalOpen && (
        <>
          <span style={{ fontSize: "18px", fontWeight: "bold" }}>
            {t("response_company.label.add_credit_card_detail")}
          </span>
          <p style={{ fontSize: "13px", color: "#667085" }}>
            {t("credit_information.credit_desc")}
          </p>

          <Flex justify="end">
            <Visa />
            <Mastercard style={{ height: 24 }} />
            <JCB style={{ height: 24 }} />
          </Flex>

          <FormAntd form={form} >
            <Flex vertical gap={16}>
              <Row align="middle">
                <Col span={7}>
                  <label>{t("credit_information.card_number")} :</label>
                </Col>
                <Col span={17}>
                  <FormInput
                    name="cardNumber"
                    size="large"
                    placeholder={t("credit_information.enter_card_number")}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>

              <Row align="middle">
                <Col span={7}>
                  <label>{t("credit_information.card_name_surename")} :</label>
                </Col>
                <Col span={17}>
                  <FormInput
                    name="cardName"
                    size="large"
                    placeholder={t("common.please_fill")}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>

              <Row align="middle">
                <Col span={7}>
                  <label>
                    {t("credit_information.card_expiration_date")} :
                  </label>
                </Col>
                <Col span={17}>
                  <Row gutter={4}>
                    <Col span={12}>
                      <FormInput
                        name="month"
                        size="large"
                        placeholder={t("credit_information.MM")}
                        style={{ width: "80%" }}
                      />
                    </Col>
                    <Col span={12} style={{ paddingRight: 0 }}>
                      <FormInput
                        name="year"
                        size="large"
                        placeholder={t("credit_information.YY")}
                        style={{ width: "80%" }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row align="middle">
                <Col span={7}>
                  <label>{t("credit_information.cvv_code")} :</label>
                </Col>
                <Col span={17}>
                  <FormInput
                    name="cvv"
                    size="large"
                    placeholder={t("credit_information.enter_password_cvv")}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            </Flex>
          </FormAntd>

          <Row justify="end" style={{ gap: "12px", marginTop: "16px" }}>
            <Button
              type="default"
              size="large"
              onClick={() => {
                setIsCreditModalOpen(false);
                form.resetFields();
              }}
            >
              {t("common.cancel").toUpperCase()}
            </Button>

            <Button
              type="primary"
              size="large"
              onClick={handCreditSave}
              style={{
                backgroundColor: "var(--button-color)",
                color: "white",
              }}
            >
              {t("common.submit").toUpperCase()}
            </Button>
          </Row>
        </>
      )}

      {isCreditInfoOpen && (
        <Flex vertical gap={24}>
          <Flex vertical>
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("response_company.label.credit_card_detail")}
            </span>
            <span style={{ color: "#667085" }}>
              {t("credit_information.credit_card_company_togetter")}
            </span>
          </Flex>

          <Card
            style={{
              borderRadius: 15,
              border: "1px solid #D9D9D9",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
            }}
          >
            <Flex vertical gap={24}>
              <Row justify="space-between" align="middle">
                <Col span={4}>
                  <Visa style={{ width: 80, height: 60 }} />
                </Col>
                <Col span={16}>
                  <span style={{ color: "#667085", fontSize: "18px" }}>xxxx xxxx xxxx 0101</span>
                </Col>

                <Col span={4}>
                  <Flex gap={8} style={{ justifyContent: "end" }}>
                    <EditOutlined
                      style={{ color: "#8392ab", fontSize: 18, cursor: "pointer" }}
                      onClick={() => {
                        setIsCreditModalOpen(true);
                        setIsCreditInfoOpen(false);
                      }}
                    />

                    <DeleteOutlined
                      style={{ color: "#8392ab", fontSize: 18, cursor: "pointer" }}
                      onClick={() => {
                      }}
                    />
                  </Flex>
                </Col>
              </Row>

              <Row>
                <Col span={4} />
                <Col span={10}>
                  <Flex vertical>
                    <span style={{ color: "#313131" }}>ชื่อผู้ถือบัตร</span>
                    <span style={{ color: "#667085", fontSize: "14px" }}>Porntipa Phichitchai</span>
                  </Flex>
                </Col>
                <Col span={10}>
                  <Flex vertical>
                    <span style={{ color: "#313131" }}>วันหมดอายุบัตร</span>
                    <span style={{ color: "#667085", fontSize: "14px" }}>07/28</span>
                  </Flex>
                </Col>
              </Row>
            </Flex>
          </Card>

          <Row justify="end" style={{ gap: "24px", marginTop: "24px" }}>
            <Button
              type="default"
              size="large"
              onClick={() => {
                onCancel();
              }}
            >
              {t("common.cancel").toUpperCase()}
            </Button>
          </Row>
        </Flex>
      )}

    </Modal>
  );
}
export default AdminCompanyModal;

